import DepsService from 'services/dependencies';

const CONTEXT = 'app';
const FILE_ERROR = 'FILE_ERROR';
const FILE_RATIO_ERROR = 'FILE_RATIO_ERROR';
const FILE_EXTENSION_ERROR = 'FILE_EXTENSION_ERROR';
const FILE_SIZE_EXCEEDED = 'FILE_SIZE_EXCEEDED';
const ICON_UPDATE_SUCCESS = 'ICON_UPDATE_SUCCESS';
const ICON_PUBLISH_SUCCESS = 'ICON_PUBLISH_SUCCESS';
const ICON_DISCARD_SUCCESS = 'ICON_DISCARD_SUCCESS';
const ICON_UPLOAD_SUCCESS = 'ICON_UPLOAD_SUCCESS';
const ICON_DELETE_SUCCESS = 'ICON_DELETE_SUCCESS';

export const fetchIcons = (config) => {
  const { jurisdiction: jurisdictionId, approved } = config;

  const requestParams = approved ? { versionType: 'APPROVED' } : {};

  const url = DepsService.config.secondHandApproval
    ? DepsService.rest.cms.icons.get.second.url
    : DepsService.rest.cms.icons.get.first.url;

  return DepsService.restSrv.get(CONTEXT, url, requestParams, { jurisdictionId });
};

export const uploadIcon = (config) => {
  const { jurisdiction: jurisdictionId, entries } = config;

  const url = DepsService.config.secondHandApproval
    ? DepsService.rest.cms.icons.put.second.url
    : DepsService.rest.cms.icons.put.first.url;

  return DepsService.restSrv.update(CONTEXT, url, { entries }, { jurisdictionId });
};

export const discardIcons = (config) => {
  const { jurisdiction: jurisdictionId } = config;

  const { url } = DepsService.rest.cms.icons.discard;

  return DepsService.restSrv.update(CONTEXT, url, null, { jurisdictionId });
};

export const errors = [
  { code: FILE_ERROR, text: () => DepsService.gettextCatalog.getString('Something went wrong during file processing. Please try again or change the file.') },
  { code: FILE_SIZE_EXCEEDED, text: () => DepsService.gettextCatalog.getString('File size exceeded. Max size 300 KB') },
  { code: FILE_EXTENSION_ERROR, text: () => DepsService.gettextCatalog.getString('File extension is invalid') },
  { code: FILE_RATIO_ERROR, text: () => DepsService.gettextCatalog.getString('Image width must be larger than its height') },
];

export const notifications = [
  { code: ICON_UPDATE_SUCCESS, text: () => DepsService.gettextCatalog.getString('Changes have been submitted for approval') },
  { code: ICON_PUBLISH_SUCCESS, text: () => DepsService.gettextCatalog.getString('Changes have been published') },
  { code: ICON_DISCARD_SUCCESS, text: () => DepsService.gettextCatalog.getString('Changes have been discarded') },
  { code: ICON_UPLOAD_SUCCESS, text: () => DepsService.gettextCatalog.getString('Icon has been uploaded') },
  { code: ICON_DELETE_SUCCESS, text: () => DepsService.gettextCatalog.getString('Icon has been deleted') },
];

export const codes = {
  FILE_ERROR,
  FILE_SIZE_EXCEEDED,
  FILE_EXTENSION_ERROR,
  FILE_RATIO_ERROR,
  ICON_UPDATE_SUCCESS,
  ICON_PUBLISH_SUCCESS,
  ICON_DISCARD_SUCCESS,
  ICON_UPLOAD_SUCCESS,
  ICON_DELETE_SUCCESS,
};



// WEBPACK FOOTER //
// ./src/modules/app/resources/manage-icons.api.js